import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";
import { Image } from "../../Instance";
import { objectToQuery } from "../../ObjectToQuery";

class ProductBrand {
    id: string;
    name!: string;
    logo: Image;
}

class AverageRating {
    name: string;
    score: number;
    max: number;
}

class RatingOption {
    id: string;
    name: string;
    max: number;
}

export class GetMarketplaceShopProductResponse {
    id: string;
    name: string;
    description: string;
    available: boolean;
    price: number;
    price_with_off: number;
    off_percent: number;
    currency: string;
    image: Image;
    images: Image[];
    brand?: ProductBrand;
    category: string;
    rating_score: string;
    max_rating_score: number;
    rating_averages: AverageRating[] = [];
    rating_options: RatingOption[] = [];
    rating_count: string;
    comments_count: string;
    favorite: boolean;
    remaining: number;
    barcode: string;
    predicted_percent: number;
}

class GetTayehMarketplaceProductsResponse {
    products: GetMarketplaceShopProductResponse[];
}

class getTyMarketplaceProductsQuery {
    page? = 0;
    per_page? = 18;
    sort?: string;
    search?: string;
    category_id?: string;
}

export function getTyMarketplaceShopProducts(username: string,params?: getTyMarketplaceProductsQuery): Promise<AxiosResponse<GetTayehMarketplaceProductsResponse>> {    
    const query = `/marketplace/${username}/products?${objectToQuery(params)}`;
    return Cirus.get(query);
}